<template>
  <div>
    <el-row>
      <el-col :span="20">
        <h4>{{ card.title }}</h4>
      </el-col>

    <div v-if="card.id">ID <b>{{ card.id }}</b></div>
    <div v-if="card.date">Date <b>{{card.date}}</b></div>

    <li v-for="(crd,index) in this.card" :data-block-id="card.id" :key="index">
          <div>{{crd.name}}</div>
    </li>
  </ul>


    </el-row>
  </div>
</template>

<script>

export default {
  name: 'kanban-card',

  props: {

    value: {
      required: true
    },

  },

  data () {
    return {
      card: (this.value ? this.value : this.data)
    }
  },

  created () {
    console.log('card', this.card)
  }
}

</script>
